import React, { Component } from 'react'
import { withStyles } from 'material-ui/styles'
import Button from 'material-ui/Button'
import Icon from 'material-ui/Icon'
import Snackbar from 'material-ui/Snackbar'
import { CircularProgress } from 'material-ui/Progress'
import Table, {
	TableBody,
	TableCell,
	TableHead,
	TableRow
} from 'material-ui/Table'
import TextField from "material-ui/TextField";
import { InputLabel } from "material-ui/Input";
import { FormControl } from "material-ui/Form";
import { FormControlLabel } from "material-ui/Form";
import Select from "material-ui/Select";
import Checkbox from 'material-ui/Checkbox'
import Switch from "material-ui/Switch";
import Dialog, {
	DialogTitle,
	DialogActions
} from 'material-ui/Dialog'
import { MenuItem } from "material-ui/Menu";
import { get } from "../../services/apiServices";
import { post } from "../../services/apiServices";
import { token } from "../../services/authServices";
import SortableTree from "react-sortable-tree";
import NodeRenderer from '../NodeRenderer'
import Grid from "material-ui/Grid";
import DotsLayoutDialog from './DotsLayoutDialog'

const styles = {
	closeIcon: {
		position: 'absolute',
		top: '10px',
		right: '10px',
		color: '#a9a9a9',
		cursor: 'pointer'
	},
	editIcon: {
		//padding: '10px',
		cursor: 'pointer'
	},
	button: {
		width: '120px',
		margin: '0 auto 40px'
	},
	headerButton: {
		marginLeft: '10px'
	},
	titleWrap: {
		marginTop: '15px',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	title: {
		color: '#3f51b5'
	},
	table: {
		minWidth: 700,
	},
	tableRow: {
		cursor: 'pointer'
	},
	progressWrapper: {
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
		alignItems: 'center',
	},
	progress: {
	},
	grid: {
		margin: "0 -24px",
		padding: "0 30px",
		textAlign: "left"
	},
	customGrid: {
		padding: "0 12px !important"
	},
};;

class StagesTree extends Component {
	expandedNodes = []
	constructor(props) {
		super(props);

		this.state = {
			'stages': this.props.stages,
			'openSnackbar': false,
			'openConfirm': false,
			'openLevel': false,
			'openStage': false,
			'message': '',
			'treeData': [],
			'currentLevel': {},
			'currentStage': {},
			'deleteId': null,
			'deleteType': '',
			'types': []
		}
	}

	componentWillMount() {
		this.getStages()
		this.getTypes()
	}

	componentWillReceiveProps(props) {
		if (props.stages && props.stages.data) {
			let treeData = this.buildTreeData(props.stages.data)
			this.setState({ treeData })
		}
	}

	getStages = () => {
		this.props.getStages()
	}

	getTypes = () => {
		get("/admin/levels/types", token).then(res => {
			if (res.status === 200) {
				this.setState({ types: res.data });
			}
		});
	};

	buildTreeData = (stages) => {
		return stages.map(stage => {
			return {
				title: <StageTreeRow stage={stage} onEdit={(e) => { this.handleOpenStageModal(stage, e) }} onDelete={(e) => { this.handleOpenConfirmModal(stage.id, 'stage', e) }} />,
				id: stage.id,
				type: "stage",
				expanded: this.expandedNodes[stage.id] ? true : false,
				item: stage,
				children: stage.levels.map(level => {
					return {
						title: <LevelTreeRow level={level} onEdit={(e) => { this.handleOpenLevelModal(level, e) }} onDelete={(e) => { this.handleOpenConfirmModal(level.id, 'level', e) }} />,
						id: level.id,
						type: "level",
						expanded: false,
						item: level
					}
				})
			}
		})
	}

	onSubmitStage = (stage, update = true) => {
		let id = stage.id ? `/${stage.id}` : ''
		//let status = stage.status ? 'enabled' : 'disabled'

		post(`/admin/stages${id}`, stage, token).then(res => {
			this.handleCloseStageModal();
			if (update) {
				this.getStages()
			}
		})
	}

	onSubmitLevel = (level, update = true) => {
		let id = level.id ? `/${level.id}` : ''
		//let status = this.state.status ? 'enabled' : 'disabled'

		post(`/admin/levels${id}`, level, token).then(res => {
			this.handleCloseLevelModal();
			if (update) {
				this.getStages()
			}
		})
	}

	onDeleteStage = () => {
		let id = this.state.deleteId
		post(`/admin/stages/${id}/delete`, {}, token).then(res => {
			this.handleCloseConfirmModal()
			this.getStages()
		}).catch(err => {
			this.setState({
				'openSnackbar': true,
				'message': `Stage id "${id}" doesn't exist`
			})
		})
	}

	onDeleteLevel = () => {
		let id = this.state.deleteId
		post(`/admin/levels/${id}/delete`, {}, token)
			.then(res => {
				this.handleCloseConfirmModal();
				this.getStages()
			})
			.catch(err => {
				this.setState({
					openSnackbar: true,
					message: `Level id "${id}" doesn't exist`
				});
			});
	}

	handleCloseSnackbar = () => {
		this.setState({
			'openSnackbar': false,
			'message': ''
		})
	}

	handleOpenConfirmModal = (id, type, e) => {
		e.stopPropagation()

		this.setState({
			'openConfirm': true,
			'deleteId': id,
			'deleteType': type
		})
	}

	handleCloseConfirmModal = () => {
		this.setState({
			'openConfirm': false,
			'deleteId': null,
			'deleteType': ''
		})
	}

	handleStageInputChange = e => {
		let state = this.state;
		state[e.target.name] = e.target.value;
		this.setState(state)
	}

	handleOpenStageModal = (stage, e) => {
		e.stopPropagation()

		this.setState({
			currentStage: stage,
			openStage: true
		})
	}

	handleOpenLevelModal = (level, e) => {
		e.stopPropagation()

		this.setState({
			currentLevel: level,
			openLevel: true
		})
	}
	handleCloseStageModal = () => {
		this.setState({
			currentStage: {},
			openStage: false
		})
	}

	handleCloseLevelModal = () => {
		this.setState({
			currentLevel: {},
			openLevel: false
		})
	}

	handleSort = (data) => {
		let node = data.node
		let type = node.type
		let item = { ...node.item }
		let treeData = data.treeData
		let prevOrder = 0
		if (type === 'stage') {
			treeData.forEach((val, index) => {
				if (val.item.id === item.id) {
					item.order = prevOrder + 1
				}
				prevOrder = val.item.order
			})
			this.onSubmitStage(item, false)
		} else {
			let parent = data.nextParentNode
			if (parent) {
				let stage = parent.item
				item.stage_id = stage.id
				parent.children.forEach((val, index) => {
					if (val.item.id === item.id) {
						item.order = prevOrder + 1
					}
					prevOrder = val.item.order
					val.item.order = index + 1
				})
			}
			this.onSubmitLevel(item, false)
		}
		return true
	}

	classes = this.props.classes;

	render() {
		const { stages } = this.props
		const { currentStage, currentLevel, openStage, openLevel } = this.state

		let isFetching = stages ? stages.isFetching : true
		let disable = true/*  */
		return (
			isFetching ?
				<div className={this.classes.progressWrapper}>
					<CircularProgress className={this.classes.progress} size={50} />
				</div>
				:
				<div>
					<Snackbar
						anchorOrigin={{
							vertical: 'top',
							horizontal: 'center',
						}}
						open={this.state.openSnackbar}
						autoHideDuration={6000}
						onClose={this.handleCloseSnackbar}
						SnackbarContentProps={{
							'aria-describedby': 'message-id',
						}}
						message={<span id="message-id">{this.state.message}</span>}
					/>
					<Dialog
						open={this.state.openConfirm}
						onClose={this.handleCloseConfirmModal}>
						<DialogTitle>
							<Icon
								className={this.classes.closeIcon}
								onClick={this.handleCloseConfirmModal}>
								close
						</Icon>
							<br />
							Are you sure you want delete this {this.state.deleteType === 'stage' ? 'stage' : 'level'}?
					</DialogTitle>
						<DialogActions className={this.classes.justifyCenter}>
							<Button
								variant="raised"
								color="primary"
								onClick={() => this.state.deleteType === 'stage' ? this.onDeleteStage() : this.onDeleteLevel()}>
								Yes
						</Button>
							<Button
								variant="raised"
								color="primary"
								onClick={this.handleCloseConfirmModal}>
								No
						</Button>
						</DialogActions>
					</Dialog>
					<StageModal onClose={this.handleCloseStageModal} open={openStage} stage={currentStage} onSubmit={this.onSubmitStage} />
					<LevelModal onClose={this.handleCloseLevelModal} open={openLevel} stages={stages} level={currentLevel} onSubmit={this.onSubmitLevel} types={this.state.types} />
					<div className={this.classes.titleWrap}>
						<h2 className={this.props.classes.title}>Stages</h2>
						<div>
							<Button
								variant="raised"
								color="primary"
								className={this.classes.headerButton}
								onClick={(e) => this.handleOpenStageModal({}, e)}>
								Add stage
					</Button>
							<Button
								variant="raised"
								color="primary"
								className={this.classes.headerButton}
								onClick={(e) => this.handleOpenLevelModal({}, e)}>
								Add level
					</Button>
						</div>
					</div>
					{
						this.state.treeData ?
							(
								<div style={{ height: '50vh' }}>
									<SortableTree
										treeData={this.state.treeData}
										onChange={treeData => this.setState({ treeData })}
										maxDepth={2}
										nodeContentRenderer={NodeRenderer}
										canNodeHaveChildren={node => node.type === "stage"}
										getNodeKey={data => {
											let node = data.node;
											return node.type === "stage"
												? "stage-" + node.id
												: "level-" + node.id;
										}}
										onMoveNode={data => {
											this.handleSort(data)
										}}
										onVisibilityToggle={(data) => {
											this.expandedNodes[`${data.node.id}`] = data.expanded ? true : false
										}}
										/*  canDrag={data => {
										  console.log(data);
										  return false;
										}} */
										canDrop={data => {
											let node = data.node;
											if (node.type === "stage" && data.nextParent !== null) {
												return false;
											} else if (node.type === "level" && data.nextParent === null) {
												return false;
											}

											return true;
										}}
									/>
								</div>
							) :
							(
								<p>Not found</p>
							)
					}
				</div>
		)
	}

}

class StageModal extends Component {
	state = {
		stage: {}
	}
	componentWillReceiveProps(props) {
		if (props.stage) {
			this.setState({ stage: props.stage })
		}
	}
	handleInputChange = e => {
		let stage = this.state.stage;
		stage[e.target.name] = e.target.value;
		this.setState({ stage })
	}
	render() {
		let stage = this.state.stage
		let disabled = !stage.name || parseInt(stage.order) < 0
			|| !(/^\d+$/.test(stage.order))
		return (
			<Dialog
				className="modal-wrap align-center"
				open={this.props.open}
				onClose={this.props.onClose}>
				<Icon
					style={styles.closeIcon}
					onClick={this.props.onClose}>
					close
					</Icon>
				{
					stage.id ?
						(
							<DialogTitle id="simple-dialog-title">
								Edit stage
							</DialogTitle>
						) :
						(
							<DialogTitle id="simple-dialog-title">
								Add stage
							</DialogTitle>
						)
				}
				<div className="input-wrap">
					<TextField
						id="name"
						label="Name"
						name="name"
						value={stage.name}
						onInput={this.handleInputChange}
						margin="normal"
						fullWidth
					/>
				</div>
				<div className="input-wrap">
					<TextField
						id="order"
						label="Order"
						name="order"
						value={stage.order}
						onInput={this.handleInputChange}
						margin="normal"
						fullWidth
					/>
				</div>
				<div className="input-wrap">
					<FormControlLabel
						control={
							<Checkbox
								checked={stage.initially_locked}
								onChange={(e) => {
									stage.initially_locked = e.target.checked ? true : false
									this.setState({
										stage
									})
								}}
								//onChange={this.handleInputChange}
								color="primary"
							/>
						}
						label="Initially Locked"
					/>
					<FormControlLabel
						control={
							<Checkbox
								checked={stage.status === 'enabled' ? true : false}
								onChange={(e) => {
									stage.status = e.target.checked ? 'enabled' : 'disabled'
									this.setState({
										stage
									})
								}}
								color="primary"
							/>
						}
						label="Enabled"
					/>
				</div>
				<Button
					variant="raised"
					color="primary"
					style={styles.button}
					onClick={() => this.props.onSubmit(stage)}
					disabled={disabled}>
					{stage.id ? "Edit" : "Add"}
				</Button>
			</Dialog>
		)
	}
}

class LevelModal extends Component {
	state = {
		level: {
			status: 'disabled'
		},
		stage: null,
		dotsModalOpen: false
	}
	componentWillReceiveProps(props) {
		if (props.level) {
			let level = { ...props.level }
			level.id = undefined
			level.order += 1
			if(!level.status){
				level.status = 'disabled'
			}
			this.setState({ level })
		}
	}
	handleInputChange = e => {
		let level = this.state.level;
		level[e.target.name] = e.target.value;
		this.setState({ level })
	}
	handleSelectTypeChange = e => {
		let level = this.state.level;
		let types = this.props.types.data;
		let type = types.filter(item => item.key === e.target.value);
		let settings = type[0].settings;
		let settingsState = {};

		for (let setting in settings) {
			let item = settings[setting];

			settingsState[setting] = item.default;
		}
		level.settings = settingsState
		level.type = e.target.value
		this.setState({ level });
	};
	handleSelectStageChange = e => {
		let level = this.state.level;
		level.stage_id = e.target.value;
		this.setState({
			level
		});
	};
	handleSettingsChange = e => {
        let newLevel = {...this.state.level};

        newLevel.settings[e.target.name] = e.target.value;
        this.setState({level: newLevel});
    };

    handleToggle = e => {
        let newLevel = {...this.state.level};

        newLevel.settings[e.target.name] = !newLevel.settings[e.target.name];
        this.setState({level: newLevel});
    };
	handleFormMatrix = (matrix) => {
		let newLevel = {...this.state.level};
		newLevel.settings['form_matrix'] = matrix
		this.setState({level: newLevel});
	};
	renderTypeItems = () => {
		let items = this.props.types;
		let result = [];
		if (items.data && items.data.length)
			[
				items.data.map((item, index) => {
					result.push(
						<MenuItem key={index} value={item.key}>
							{item.name}
						</MenuItem>
					);
				})
			];

		return result.map(item => item);
	};
	renderStageItems = () => {
		let items = this.props.stages;
		let result = [];

		if (items.data && items.data.length)
			[
				items.data.map((item, index) => {
					result.push(
						<MenuItem key={index} value={item.id}>
							{item.name}
						</MenuItem>
					);
				})
			];

		return result.map(item => item);
	};
	renderTypeSettings = () => {
		let level = this.state.level
		let types = this.props.types.data
		let type = types.filter(item => item.key === level.type);
		let settings = type[0].settings;
		let result = [];
		this.disabled = false;

		for (let setting in settings) {
			let item = settings[setting];
			if(item["depends_on"] && (!level.settings || item["depends_on_value"] != level.settings[item["depends_on"]])) {
				continue;
			}
			switch (item.type) {
				case "text":
					const flags = item.validation.replace(
						/.*\/([gimy]*)$/,
						"$1"
					);
					const pattern = item.validation.replace(
						new RegExp("^/(.*?)/" + flags + "$"),
						"$1"
					);
					const regex = new RegExp(pattern, flags);
					const error = !regex.test(level.settings[setting]);

					this.disabled = this.disabled ? this.disabled : error;
					result.push(
						<Grid
							style={styles.customGrid}
							item
							sm={6}
							key={setting}
						>
							<TextField
								error={error}
								id={setting}
								label={item.label}
								name={setting}
								defaultValue={level.settings[setting]}
								onChange={this.handleSettingsChange}
								margin="normal"
								fullWidth
							/>
						</Grid>
					);
					break;
				case "select":
					result.push(
						<Grid
							style={styles.customGrid}
							item
							sm={12}
							key={setting}
						>
							<FormControl style={styles.formControl}>
								<InputLabel htmlFor={setting}>
									{item.label}
								</InputLabel>
								<Select
									value={level.settings[setting]}
									onChange={this.handleSettingsChange}
									inputProps={{
										id: setting,
										name: setting
									}}
									autoWidth
								>
									{item.options
										? item.options.map((i, index) => {
											return (
												<MenuItem
													key={index}
													value={i}
												>
													{i}
												</MenuItem>
											);
										})
										: ""}
								</Select>
							</FormControl>
						</Grid>
					);
					break;
				case "number":
					result.push(
						<Grid
							style={styles.customGrid}
							item
							sm={6}
							key={setting}
						>
							<TextField
								id={setting}
								label={item.label}
								type="number"
								name={setting}
								value={level.settings[setting]}
								onInput={this.handleSettingsChange}
								margin="normal"
								fullWidth
							/>
						</Grid>
					);
					break;
				case "toggle":
					result.push(
						<Grid
							style={styles.customGrid}
							item
							sm={6}
							key={setting}
						>
							<InputLabel>{item.label}</InputLabel>
							<div>
								<Switch
									checked={level.settings[setting]}
									name={setting}
									onChange={this.handleToggle}
									color="primary"
								/>
							</div>
						</Grid>
					);
					break;
				case "matrix":
					result.push(
						<Grid
							style={styles.customGrid}
							item
							sm={6}
							key={setting}
						>
							<Button
								variant="raised"
								color="primary"
								onClick={() => this.setState({ dotsModalOpen: true })}
							>
								{item.label}
							</Button>
						</Grid>
					);
					break;
			}
		}

		return result.map(item => item);
	};
	render() {
		let { stage, level } = this.state
		let disabled =
			!level.description ||
			!level.type ||
			!level.stage_id ||
			!level.instruction ||
			!level.questions_count ||
			!level.order;
		return (
			<div>
				<DotsLayoutDialog onChange={this.handleFormMatrix} open={this.state.dotsModalOpen} onClose={() => this.setState({ dotsModalOpen: false })} matrix={level.settings ? level.settings['form_matrix'] : null} />

				<Dialog
					className="modal-wrap align-center"
					open={this.props.open}
					onClose={this.props.onClose}>

					<Grid
						container
						style={styles.grid}
						spacing={24}
					>
						<Icon
							style={styles.closeIcon}
							onClick={this.props.onClose}>

							close
                        </Icon>
						{level.id ? (
							<Grid className="align-center" item sm={12}>
								<DialogTitle id="simple-dialog-title">
									Edit level
                                </DialogTitle>
							</Grid>
						) : (
								<Grid className="align-center" item sm={12}>
									<DialogTitle id="simple-dialog-title">
										Add level
                                </DialogTitle>
								</Grid>
							)}
						{this.props.stages && <Grid style={styles.customGrid} item sm={12}>
							<FormControl style={styles.customGrid}>
								<InputLabel htmlFor="stage-select">
									Stage
                                    </InputLabel>
								<Select
									value={level.stage_id || 0}
									onChange={this.handleSelectStageChange}
									inputProps={{
										id: "stage-select",
										name: "activeStageId"
									}}
									autoWidth
								>
									{this.renderStageItems()}
								</Select>
							</FormControl>
						</Grid>}
						<Grid style={styles.customGrid} item sm={12}>
							<TextField
								id="description"
								label="Description"
								name="description"
								multiline
								rows="1"
								value={level.description}
								onChange={this.handleInputChange}
								margin="normal"
								fullWidth
							/>
						</Grid>
						<Grid style={styles.customGrid} item sm={12}>
							<TextField
								id="instruction"
								label="Instruction"
								name="instruction"
								multiline
								rows="1"
								value={level.instruction}
								onChange={this.handleInputChange}
								margin="normal"
								fullWidth
							/>
						</Grid>
						{stage && stage.name === 'Challenge' && 
						<Grid className={styles.customGrid} item sm={12}>
							<TextField
								id="challenge_text1"
								label="Challenge Text 1 (Topic Title)"
								name="challenge_text1"
								multiline
								rows="1"
								value={level.challenge_text1}
								onChange={this.handleInputChange}
								margin="normal"
								fullWidth
							/>
						</Grid>}
						{stage && stage.name === 'Challenge' && 
						<Grid className={styles.customGrid} item sm={12}>
							<TextField
								id="challenge_text2"
								label="Challenge Text 2 (Skill name)"
								name="challenge_text2"
								multiline
								rows="1"
								value={level.challenge_text2}
								onChange={this.handleInputChange}
								margin="normal"
								fullWidth
							/>
						</Grid>}
						{stage && stage.name === 'Challenge' && 
						<Grid className={styles.customGrid} item sm={12}>
							<TextField
								id="challenge_text3"
								label="Challenge Text 3 (Skill subname)"
								name="challenge_text3"
								multiline
								rows="1"
								value={level.challenge_text3}
								onChange={this.handleInputChange}
								margin="normal"
								fullWidth
							/>
						</Grid>}
						<Grid style={styles.customGrid} item sm={12}>
							<TextField
								id="questions_count"
								label="Questions count"
								type="number"
								name="questions_count"
								value={level.questions_count}
								onInput={this.handleInputChange}
								margin="normal"
								fullWidth
							/>
						</Grid>
						{stage && stage.name === 'Challenge' ? (<React.Fragment>
							<Grid className={styles.customGrid} item sm={12}>
								<TextField
									id="challenge_unlock_question_count"
									label="Unlock Questions Count"
									type="number"
									name="challenge_unlock_question_count"
									value={level.challenge_unlock_question_count}
									onInput={this.handleInputChange}
									margin="normal"
									fullWidth
								/>
							</Grid>
						</React.Fragment>) : (<React.Fragment>
							<Grid className={styles.customGrid} item sm={12}>
								<TextField
									id="one_stars_rating_value"
									label="1 Star Average Coin Count"
									type="number"
									name="one_stars_rating_value"
									value={level.one_stars_rating_value}
									onInput={this.handleInputChange}
									margin="normal"
									fullWidth
								/>
							</Grid>
							<Grid className={styles.customGrid} item sm={12}>
								<TextField
									id="two_stars_rating_value"
									label="2 Star Average Coin Count"
									type="number"
									name="two_stars_rating_value"
									value={level.two_stars_rating_value}
									onInput={this.handleInputChange}
									margin="normal"
									fullWidth
								/>
							</Grid>
							<Grid className={styles.customGrid} item sm={12}>
								<TextField
									id="three_stars_rating_value"
									label="3 Star Average Coin Count"
									type="number"
									name="three_stars_rating_value"
									value={level.three_stars_rating_value}
									onInput={this.handleInputChange}
									margin="normal"
									fullWidth
								/>
							</Grid>
						</React.Fragment>)}
						<Grid style={styles.customGrid} item sm={6}>
							<TextField
								id="order"
								label="Order"
								type="number"
								name="order"
								value={level.order}
								onInput={this.handleInputChange}
								margin="normal"
								fullWidth
							/>
						</Grid>
						<Grid style={styles.customGrid} item sm={6}>
							<InputLabel>Status</InputLabel>
							<div>
								<FormControlLabel
									control={
										<Checkbox
											checked={level.status === 'enabled' ? true : false}
											onChange={(e) => {
												level.status = e.target.checked ? 'enabled' : 'disabled'
												this.setState({
													level
												})
											}}
											color="primary"
										/>
									}
									label="Enabled"
								/>
							</div>
						</Grid>
						<Grid style={styles.customGrid} item sm={12}>
							<InputLabel>Show Level Info</InputLabel>
							<div>
								<FormControlLabel
									control={
										<Checkbox
											checked={level.show_level_info}
											onChange={() => {
												let level = this.state.level;
												level.show_level_info = !level.show_level_info;
												this.setState({
													level
												});

											}

											}
											color="primary"
										/>
									}
									label="Show"
								/>
							</div>
						</Grid>
						{level.show_level_info && <React.Fragment>
							<Grid className={styles.customGrid} item sm={12}>
								<TextField
									id="level_info_title"
									label="Level Info Title"
									type="text"
									name="level_info_title"
									value={level.level_info_title}
									onInput={this.handleInputChange}
									margin="normal"
									multiline
									fullWidth
								/>
							</Grid>
							<Grid className={styles.customGrid} item sm={12}>
								<TextField
									id="level_info_description"
									label="Level Info Description"
									type="text"
									name="level_info_description"
									value={level.level_info_description}
									onInput={this.handleInputChange}
									margin="normal"
									multiline
									fullWidth
								/>
							</Grid>
							
							<Grid className={styles.customGrid} item sm={12}>
								<FormControlLabel
									control={
										<Checkbox
											checked={level.level_image_auto}
											onChange={() => {
												let level = this.state.level;
												level.level_image_auto = !level.level_image_auto;
												this.setState({
													level
												});

											}

											}
											color="primary"
										/>
									}
									label="Level Info Image Automatic?"
								/>
								<TextField
									disabled={level.level_image_auto}
									id="level_info_image_url"
									label="Level Info Image URL"
									type="text"
									name="level_info_image_url"
									value={level.level_info_image_url}
									onInput={this.handleInputChange}
									margin="normal"
									multiline
									fullWidth
								/>
							</Grid>
						</React.Fragment>}
						{/* level.show_level_info && <Grid style={styles.customGrid} item sm={6}>
                                <TextField
                                    id="level_info_video_url"
                                    label="Level Info Video Url"
                                    type="text"
                                    name="level_info_video_url"
                                    value={level.level_info_video_url}
                                    onInput={this.handleInputChange}
                                    margin="normal"
                                    fullWidth
                                />
                            </Grid> */}
						<Grid style={styles.customGrid} item sm={12}>
							<FormControl style={styles.formControl}>
								<InputLabel htmlFor="type-select">
									Type
                                </InputLabel>
								<Select
									value={level.type || ''}
									onChange={this.handleSelectTypeChange}
									inputProps={{
										id: "type-select",
										name: "activeType"
									}}
									autoWidth
								>
									{this.renderTypeItems()}
								</Select>
							</FormControl>
						</Grid>
						{level.type ? this.renderTypeSettings() : []}
						<Grid item sm={12}>
							<DialogActions className="align-center">
								<Button
									variant="raised"
									color="primary"
									style={styles.button}
									onClick={() => this.props.onSubmit(level)}
									disabled={disabled}
								>
									{level.id ? "Edit" : "Add"}
								</Button>
							</DialogActions>
						</Grid>
					</Grid>
				</Dialog>
			</div>
		)
	}
}

class StageTreeRow extends Component {
	render() {
		let stage = this.props.stage
		return (
			<Grid
				container spacing={24}>
				<Grid item className='tree-col'>{stage.name}</Grid>
				<Grid item className='tree-col'>{stage.levels.length}</Grid>
				<Grid item className='tree-col'>
					<Icon
						style={styles.editIcon}
						onClick={this.props.onEdit}>
						mode_edit
						</Icon>
				</Grid>
				<Grid item className='tree-col'>
					<Icon
						style={styles.editIcon}
						onClick={this.props.onDelete}>
						delete
						</Icon>
				</Grid>
			</Grid>
		)
	}
}

class LevelTreeRow extends Component {
	state = {
		level: {}
	}
	componentWillMount() {
		this.setState({ level: this.props.level })
	}
	toSingleLevel = id => {
		window.location.href = `/admin/levels/${id}/edit`
	}
	onStatusChange = (item, event) => {
		let level = this.state.level
		level.status = event.target.checked ? 'enabled' : 'disabled'

		this.setState({ level })
		post(
			`/admin/levels/${item.id}`,
			level,
			token
		)
			.catch(err => {
				this.setState({
					openSnackbar: true,
					message: "The given data was invalid."
				});
			});
	}
	render() {
		let level = this.state.level
		let value_1 = level.settings.value_1 || ''
		let value_2 = level.settings.value_2 || ''
		let answer = level.settings.answer || ''
		let operation = level.settings.operation || ''
		return (
			<Grid
				container spacing={24}>
				<Grid item className='tree-col'>{level.order < 10 ? '0' + level.order : level.order}</Grid>
				<Grid item className='tree-col'>{level.description}</Grid>
				<Grid item className='tree-col'>{level.type}</Grid>
				{value_1 && <Grid item className='tree-col'>{value_1}</Grid>}
				{value_2 && <Grid item className='tree-col'>{value_2}</Grid>}
				{answer && <Grid item className='tree-col'>{answer}</Grid>}
				{operation && <Grid item className='tree-col'>{operation}</Grid>}
				<Grid item className='tree-col'><Switch
					checked={level.status === 'enabled' ? true : false}
					name='status'
					onChange={(event) => {
						this.onStatusChange(level, event)
					}}
					color="primary"
				/>
				</Grid>
				<Grid item className='tree-col'>
					<Icon
						style={styles.editIcon}
						onClick={e => this.toSingleLevel(level.id)}
					>
						mode_edit
                        </Icon>
				</Grid>
				<Grid item className='tree-col'>
					<Icon
						style={styles.editIcon}
						onClick={this.props.onEdit}>

						content_copy
                        </Icon>
				</Grid>
				<Grid item className='tree-col'>
					<Icon
						style={styles.editIcon}
						onClick={this.props.onDelete}>

						delete
                        </Icon>
				</Grid>
			</Grid>
		)
	}
}

export default withStyles(styles)(StagesTree);



// WEBPACK FOOTER //
// ./src/components/content/StagesTree.js